import setValue from './setValue'

export const BASKET_LOADING = 'loading'
export const BASKET_LOADED = 'loaded'
export const BASKET_FAILED = 'failed'
export const BASKET_STATE = 'basketLoading'
export const BASKET_DATA = 'basket'

const updateBasket = (data) => dispatch => dispatch(setValue(BASKET_DATA, data))

export const setBasketState = (state = BASKET_LOADING) => dispatch => dispatch(setValue(BASKET_STATE, state))
export const resetBasket = () => dispatch => {
  dispatch(setValue(BASKET_STATE, BASKET_LOADING))
  dispatch(setValue(BASKET_DATA, undefined))
}
export default updateBasket
